import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        boxShadow: 'none',
        '& input': {
          fontFamily: 'avenirnext-regular',
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '22px',
          color: '#424242',
        },
        '& label': {
          fontSize: '16px',
          lineHeight: '22px',
          color: '#818181',
        },
      },
    },
    MuiInputLabel: {
      root: {
        '&$focused': {
          color: '#00bfa5',
        },
      },
      asterisk: {
        display: 'none',
      },
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: '1px solid #818181 !important',
        },
        '&:after': {
          borderBottom: '2px solid #00bfa5 !important',
        },
      },
    },
  },
});

export default function StyledComponents({
  id,
  className,
  label,
  name,
  type,
  onChange,
  tabIndex,
  defaultValue,
  margin,
  autoFocus,
  required,
  autoComplete,
  error,
  helperText,
  value,
}) {
  return (
    <MuiThemeProvider theme={theme}>
      <TextField
        id={id}
        className={className}
        label={label}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        tabIndex={tabIndex}
        defaultValue={defaultValue}
        margin={margin}
        autoFocus={autoFocus}
        required={required}
        autoComplete={autoComplete}
        error={error}
        helperText={helperText}
      />
    </MuiThemeProvider>
  );
}

StyledComponents.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  tabIndex: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  margin: PropTypes.string,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  autoComplete: PropTypes.string,
  helperText: PropTypes.string,
  error: PropTypes.bool,
};

StyledComponents.defaultProps = {
  className: '',
  onChange: () => {},
  tabIndex: null,
  defaultValue: '',
  value: null,
  margin: 'normal',
  autoFocus: false,
  required: false,
  autoComplete: 'off',
  helperText: null,
  error: false,
};
